/// <reference types="@types/googlemaps" />
import { UpperCasePipe } from '@angular/common';
import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  ElementRef,
  OnDestroy,
  ViewChild,
  ViewContainerRef,
  ViewRef,
} from '@angular/core';
import { MapLayerIDs } from '@app/shared/static-data/map-options';
import { MapService } from '@services/map.service';
import { Subscription } from 'rxjs';
import { getRegionalMapSettings } from '@services/utils/region';

const defaultConfig = {
  lat: getRegionalMapSettings().center.lat,
  lng: getRegionalMapSettings().center.lng,
  zoom: getRegionalMapSettings().zoom,
  fitBounds: false,
  mapTypeId: 'default',
  styles: undefined,
};

@Component({
  selector: 'app-map',
  templateUrl: './map.component.html',
  styleUrls: ['./map.component.scss'],
  providers: [UpperCasePipe],
  standalone: false,
})
export class MapComponent implements AfterViewInit, OnDestroy {
  configSub: Subscription;
  config = defaultConfig;
  oldStyles: google.maps.MapTypeStyle[];
  styles: google.maps.MapTypeStyle[];
  darkStyles: google.maps.MapTypeStyle[];
  mapTypeId: keyof typeof google.maps.MapTypeId = 'ROADMAP';
  @ViewChild('vc', { read: ViewContainerRef, static: false })
  vc: ViewContainerRef;

  constructor(
    private service: MapService,
    private hostElement: ElementRef,
    private cd: ChangeDetectorRef,
    upperCasePipe: UpperCasePipe,
  ) {
    this.oldStyles = this.service.oldStyles;
    this.styles = this.service.styles;
    this.darkStyles = this.service.darkStyles;

    this.configSub = service.config$$.subscribe((config: any) => {
      if (!config.mapTypeId) {
        return;
      }

      if (!config) {
        return;
      }

      if (!config.mapTypeId) {
        this.config = {
          ...this.config,
          ...{ lat: 0, lng: 0, zoom: 0 },
        };
        if (!(this.cd as ViewRef).destroyed) {
          this.cd.detectChanges();
        }
      }
      this.config = {
        ...this.config,
        ...config,
      };
      this.mapTypeId =
        config.mapTypeId === 'default'
          ? MapLayerIDs.ROADMAP
          : config.mapTypeId === 'hybrid3d'
            ? MapLayerIDs.HYBRID
            : google.maps.MapTypeId[upperCasePipe.transform(config.mapTypeId)];
    });
  }

  ngAfterViewInit(): void {
    this.service.setElementsReferences(this.hostElement.nativeElement, this.hostElement.nativeElement.parentElement);
    this.service.setRootViewContainerRef(this.vc);
  }

  ngOnDestroy(): void {
    this.configSub.unsubscribe();
  }

  onZoomChange(zoom) {
    this.service.zoomChange$$.next(zoom);
  }

  onMapReady(map) {
    this.service.mapInstance = map;
  }

  onBoundsChange(newBounds: google.maps.LatLngBounds) {
    this.service.onBoundsChange$$.next(newBounds);
    const bounds = JSON.parse(JSON.stringify(newBounds));
    if (bounds && bounds.north > 1) {
      // set tiles when real bounds exists
      this.service.setMapTilesLoaded(true);
    }
  }
}
